export default () => ({
  container: {
    width: '100%',
    maxWidth: '1160px',
    mx: 'auto',
    px: 2
  }
});
